import { ContextMenu } from '~/components/ContextMenu/ContextMenu';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { Pagination } from '~/components/Pagination/Pagination';
import { TeamListFilter } from './components/team-list-filter';
import { TeamListTable } from './components/team-list-table';
import { useFilterForm } from '~/hooks/useFilterForm';
import { useTeamsListQuery } from '../queries';
import { Fragment } from 'react/jsx-runtime';
import { querySchema } from './query-schema';

export function Page() {
  const { values } = useFilterForm(querySchema.parse);

  const { data, isLoading } = useTeamsListQuery({
    page_size: values.pageSize,
    ordering: values.ordering,
    page: values.pageIndex,
    search: values.search,
  });

  return (
    <Fragment>
      <PageLayout.Header>
        <PageLayout.Heading text="Lag" />

        <PageLayout.Context items={[<ContextMenu.Item label="Skapa lag" to="create" key="create" />]} />
      </PageLayout.Header>

      <PageLayout.Section>
        <TeamListFilter />
        <TeamListTable teams={data?.results ?? []} isLoading={isLoading} />
        <Pagination count={data?.count} />
      </PageLayout.Section>
    </Fragment>
  );
}
